import { LocalStorage } from 'quasar';
import { route } from 'quasar/wrappers';
import { LocalStorageKeys, Routes } from 'src/constants';
import { useAccountStore } from 'src/stores/account';
import {
	createMemoryHistory,
	createRouter,
	createWebHashHistory,
	createWebHistory,
} from 'vue-router';
import routes from './routes';

const RUNNING_IN_PRODUCTION = process.env.NODE_ENV === 'production';

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route(function (/* { store, ssrContext } */) {
	const createHistory = process.env.SERVER
		? createMemoryHistory
		: process.env.VUE_ROUTER_MODE === 'history'
		? createWebHistory
		: createWebHashHistory;

	const Router = createRouter({
		scrollBehavior: () => ({ left: 0, top: 0 }),
		routes,

		// Leave this as is and make changes in quasar.conf.js instead!
		// quasar.conf.js -> build -> vueRouterMode
		// quasar.conf.js -> build -> publicPath
		history: createHistory(
			process.env.MODE === 'ssr' ? void 0 : process.env.VUE_ROUTER_BASE
		),
	});

	Router.beforeEach((to, from, next) => {
		const accountStore = useAccountStore();

		const isLoggedIn = !!accountStore.userLogin?.token;
		const isAccessingRestrictedPage = !to.meta?.allowAnonymous;

		// Only limit the amount of times the user sees the splash page if we're running in production
		if (RUNNING_IN_PRODUCTION) {
			// Make sure the user has seen the splash page before he sees the log in page
			const hasUserSeenSplashPage = LocalStorage.getItem(
				LocalStorageKeys.HAS_USER_SEEN_SPLASH_PAGE
			);
			if (to.name === Routes.LOG_IN && !hasUserSeenSplashPage) {
				return next({ name: Routes.SPLASH });
			}
		}

		if (isAccessingRestrictedPage) {
			if (isLoggedIn) {
				// Only limit the amount of times the user sees the start page if we're running in production
				if (RUNNING_IN_PRODUCTION) {
					// Make sure the user has filled out the start page before proceeding into the app
					const hasUserFilledOutStartPage = LocalStorage.getItem(
						`${LocalStorageKeys.HAS_USER_FILLED_OUT_START_PAGE}-${accountStore.userId}`
					);
					if (!hasUserFilledOutStartPage && to.name !== Routes.START) {
						return next({ name: Routes.START });
					}
				}

				return next();
			} else {
				return next({ name: Routes.LOG_IN });
			}
		} else {
			if (to.name === Routes.LOG_IN && isLoggedIn) {
				return next({ name: Routes.LOG });
			}
			next();
		}
	});

	return Router;
});
